<p-menubar [model]="menus" styleClass="iam-menu menu-78"></p-menubar>
